import { Box, InputBase, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { changePassword } from "../../../api/user";
import userPic from "../../../assets/image/changePasswordIcon.png";
import EyeClosedIcon from "../../../assets/SVG/eyeClosedIcon";
import EyeOpenIcon from "../../../assets/SVG/eyeOpenIcon";
import LockIcon from "../../../assets/SVG/lockIcon";

export default function CheangPassPop({ open, setOpen }) {
  const styleLabel = {
    color: "#2B2B2B",
    textAlign: "right",
    fontSize: "16px",
    fontWeight: "600",
  };
  const [showPassword, setShowPassword] = useState();
  const [showPassword1, setShowPassword1] = useState();
  const [showPassword3, setShowPassword3] = useState();
  const [dataPass, setDataPass] = useState({
    currPassword: "",
    password: "",
    repeatPassword: "",
  });
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      //   sx={{}}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 750,
          height: 350,
          bgcolor: "white",
          boxShadow: 24,
          p: 5,
          borderRadius: "23px",
          ":focus-visible": {
            outline: "none !important",
            border: "none !important",
          },
        }}
      >
        <Box display="flex" alignItems="center" gap="20px">
          <Box width="40%" borderLeft="1px solid #98C2CB" height={"350px"}>
            <img src={userPic} />
          </Box>
          <Box display="grid" width={"100%"} height="350px" pl="20px">
            <Box mx="0px" my="0px">
              <Typography mt="10px" sx={styleLabel} display="flex">
                {"رمز عبور قدیمی "}
                <Typography color="red" mr="5px">
                  *
                </Typography>
              </Typography>
              <Box
                sx={{
                  border: "solid 1px var(--emr-borderInput)",
                  borderRadius: "8px",
                  px: "10px",
                  height: "50px",
                  display: "flex",
                  mt: "5px",
                  boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <LockIcon />
                <InputBase
                  sx={{ width: "80%" }}
                  type={!showPassword3 ? "password" : "text"}
                  value={dataPass?.currPassword}
                  onChange={(e) =>
                    setDataPass({ ...dataPass, currPassword: e.target.value })
                  }
                  placeholder="رمز عبور قدیمی  خود را وارد کنید."
                />
                {dataPass.currPassword && (
                  <Box
                    sx={{ cursor: "pointer", mt: "5px" }}
                    onClick={() => setShowPassword3(!showPassword3)}
                  >
                    {!showPassword3 ? <EyeOpenIcon /> : <EyeClosedIcon />}
                  </Box>
                )}
              </Box>
            </Box>
            <Box mx="0px" my="0px">
              <Typography mt="10px" sx={styleLabel} display="flex">
                {"رمز عبور جدید "}
                <Typography color="red" mr="5px">
                  *
                </Typography>
              </Typography>
              <Box
                sx={{
                  border: "solid 1px var(--emr-borderInput)",
                  borderRadius: "8px",
                  px: "10px",
                  height: "50px",
                  display: "flex",
                  mt: "5px",
                  boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <LockIcon />
                <InputBase
                  sx={{ width: "80%" }}
                  type={!showPassword ? "password" : "text"}
                  value={dataPass.password}
                  onChange={(e) =>
                    setDataPass({ ...dataPass, password: e.target.value })
                  }
                  placeholder="رمز عبور جدید  خود را وارد کنید."
                />
                {dataPass.password && (
                  <Box
                    sx={{ cursor: "pointer", mt: "5px" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {!showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
                  </Box>
                )}
              </Box>
            </Box>
            <Box mx="0px" mt="0px">
              <Typography mt="10px" sx={styleLabel} display="flex">
                {"تکرار رمز عبور جدید "}
                <Typography color="red" mr="5px">
                  *
                </Typography>
              </Typography>
              <Box
                sx={{
                  border: "solid 1px var(--emr-borderInput)",
                  borderRadius: "8px",
                  px: "10px",
                  height: "50px",
                  display: "flex",
                  mt: "5px",
                  boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <LockIcon />
                <InputBase
                  sx={{ width: "80%" }}
                  type={!showPassword1 ? "password" : "text"}
                  value={dataPass.repeatPassword}
                  onChange={(e) =>
                    setDataPass({ ...dataPass, repeatPassword: e.target.value })
                  }
                  placeholder="تکرار رمز عبور جدید  خود را وارد کنید."
                />
                {dataPass?.repeatPassword && (
                  <Box
                    sx={{ cursor: "pointer", mt: "5px" }}
                    onClick={() => setShowPassword1(!showPassword1)}
                  >
                    {!showPassword1 ? <EyeOpenIcon /> : <EyeClosedIcon />}
                  </Box>
                )}
              </Box>
            </Box>
            <button
              onClick={() => {
                changePassword(dataPass)
                  .then(() => {
                    setOpen(false);
                  })
                  .catch((x) => {
                    toast.error(x.data?.fields?.password);
                  });
              }}
              style={{
                borderRadius: "7px",
                background: "#126E83",
                border: "none",
                height: "40px",
                // padding: "5px 0px",
                marginTop: "5px",
                fontSize: "20px",
                color: "white",
                marginTop: "10px",
              }}
            >
              {"ویرایش رمزعبور"}
            </button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
